import { Button, Container } from '@react-email/components';
import { getLinkSesTags } from '@Utils/general';
import { merge } from 'lodash';
import { useSlate } from 'slate-react';

const button = {
    EditorElement: props => {
        const { attributes, children, element } = props;

        const editor = useSlate();

        const textCursorStyle = { style: { cursor: 'text' } };

        const theme = editor.children[0].theme;

        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };

        return (
            <Container
                {...attributes}
                {...merge(
                    textCursorStyle,
                    element.containerAttributes,
                    containerStyle,
                )}
            >
                <Button {...merge({}, theme.button, element.attributes)}>
                    {children}
                </Button>
            </Container>
        );
    },
    PreviewElement: ({ node, originalNode, attributes, editor, children }) => {
        const theme = editor.children[0].theme;
        const containerStyle = {
            style: {
                maxWidth: '100%',
            },
        };

        return (
            <Container {...merge({}, node.containerAttributes, containerStyle)}>
                <Button
                    // id={buttonPath}
                    // ses-tags={`text:${buttonText};url:${attributes.href};path:${buttonPath}`}
                    {...getLinkSesTags(editor, originalNode)}
                    {...merge({}, theme.button, attributes)}
                >
                    {children}
                </Button>
            </Container>
        );
    },
};

export default button;
